import './vacancy.scss';
import {useEffect, useState} from "react";
import {useTranslations} from "../../graphql/query.hooks/translation.hook";
import VacancyCard from "../../components/uiElements/cards/vacancyCard/VacancyCard";
import {useVacancies} from "../../graphql/query.hooks/vacancy.hook";


export default function Vacancy() {
    const translations = useTranslations()

    useEffect(() => {
        window.scrollTo({
            top: 0,
        });
    }, [])

    const {data: vacanciesData, loading: loadingPartners} = useVacancies();

    console.log(vacanciesData,'vacanciesDatavacanciesData')
    return <div className={'vacancies-wrapper'} >
        <div className={'header-block'}>
            <div className={'top'}/>
            <div className={'content'}>
                <div className={'inner'}>
                    <h2 className={'header-title'}>{translations?.vacancy_page_title}</h2>
                    <div className={'header-description'}>
                        {translations?.vacancy_page_description}
                    </div>
                </div>
            </div>
        </div>

        <div className={'vacancies_list_wrapper'}>
            <div className={`vacancies_list`}>
                {
                    !!vacanciesData?.length && vacanciesData?.map((item,) => {
                        return <VacancyCard key={item.id}
                                            vacancy={item}
                                            translations={translations}/>
                    })
                }
            </div>
        </div>
    </div>
}